import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { SessionProvider } from './providers/SessionProvider';
import { DataProvider } from './providers/DataProvider';
import { router } from './router';

/**
 * `FiltersProvider` is mounted inside the router (in `AppShell`) rather than
 * here, because it reads and writes the URL and therefore needs a router
 * context above it.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Freshness is a domain concept in this product, surfaced through
      // `meta.sourceStatus`. The cache should not invent its own opinion about
      // it: we keep data until a mutation or a scope change invalidates it, and
      // let the SourceBadge tell the truth about age.
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <DataProvider>
          <RouterProvider router={router} />
        </DataProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
}
